<template>
  <span :data-test="`recruiter-fee-${rowIndex}`">
    {{ column.recruiterManagesWorkers ? '-' : (additiveFeesText || '-') }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { FeeApplication } from '@/gql/graphql'

const CompanyRecruiterFeeColumn = graphql(`
  fragment CompanyRecruiterFeeColumn on CompanyRecruiter {
    fees {
      id
      application
      formattedRate
    }
    recruiterManagesWorkers
  }
`)

const props = defineProps<{
  row: FragmentType<typeof CompanyRecruiterFeeColumn>
  rowIndex?: number
}>()
const column = computed(() => useFragment(CompanyRecruiterFeeColumn, props.row))
const additiveFeesText = computed(() =>
  column.value.fees
    .filter((fee) => fee.application === FeeApplication.Additive)
    .map((fee) => fee.formattedRate)
    .join(' + '),
)
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
